import React from 'react'
import { Layout } from 'antd'
import styled from 'styled-components'
import { GeneralFooter } from '../layouts/components/GeneralFooter'

const { Content } = Layout

type Props = {
  currentPage?: string
  title: string
}

export const MapLayout: React.FC<Props> = ({ currentPage, children }) => {

  return (
    <BaseLayout>
      <Layout>
        <Content style={{ backgroundColor: 'white' }}>{children}</Content>
      </Layout>
      <GeneralFooter />
    </BaseLayout>
  )
}
const BaseLayout = styled(Layout)`
  min-height: 100vh;
  background-color: white;
`
